import PropTypes from "prop-types";
import React from "react";

import FormButton from "../form/FormButton";
import Image from "../interface/Image";

const InspectorImageWell = props => {
  return (
    <div className="inspectorImageWell">
      {props.source ? (
        <Image source={props.source} alt={props.alt} showMissingLabel={true} onDoubleClick={props.onView} />
      ) : null}
      {props.source && props.onDelete ? (
        <FormButton label="Delete" onClick={props.onDelete} destructive={true} />
      ) : null}
    </div>
  );
};

InspectorImageWell.propTypes = {
  source: PropTypes.string.isRequired,
  alt: PropTypes.string,
  onDelete: PropTypes.func,
  onView: PropTypes.func
};

export default InspectorImageWell;
